import styled from "styled-components";
import type { GlobalToken } from "antd";

export interface TokenProps {
  $token: GlobalToken;
}

// One viewport tall so the sidebar stays fixed and each column scrolls
// internally instead of the whole page scrolling under the chrome.
export const Page = styled.div<TokenProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  font-family: ${({ $token }) => $token.fontFamily};

  /* No background: inherit the admin layout's neutral gray (colorBgLayout
     #f5f5f5) rather than theme-v2's teal tint. */

  @media (width <= 1000px) {
    height: auto;
    min-height: 100%;
    overflow: visible;
  }
`;

export const Header = styled.div`
  flex-shrink: 0;
  padding: 56px 40px 0;
  text-align: center;

  @media (width <= 1000px) {
    padding: 32px 20px 0;
  }
`;

export const Title = styled.h1<TokenProps>`
  font-size: ${({ $token }) => $token.fontSizeHeading1}px;
  font-weight: 300;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: ${({ $token }) => $token.colorText};
  margin: 0;
`;

export const Row = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: stretch;
  overflow: hidden;

  @media (width <= 1000px) {
    flex-direction: column;
    overflow: visible;
  }
`;
